export enum EvidenceStatus {
  loaded = 'LOADED',
  conduentDelivered = 'CONDUENT_DELIVERED',
  duncanDelivered = 'DUNCAN_DELIVERED',
  rejected = 'REJECTED',
  scheduled = 'SCHEDULED',
  ignored = 'IGNORED',
  error = 'ERROR',
  created = 'CREATED',
  deliveryError = 'DELIVERY_ERROR',
  pendingRemoval = 'PENDING_REMOVAL',
  removed = 'REMOVED',
  verraNotified = 'VERRA_NOTIFIED',
  ftpDelivered = 'FTP_DELIVERED',
  processing = 'PROCESSING',
  notfound = 'NOTFOUND',
  systemUnavailable = 'SYSTEM_UNAVAILABLE',
}
